/**
 * package: com.inq.flash.client.data
 * class: MessageFields
 * root Object
 */
com.inq.flash.client.data.MessageFields = {};

/** @type {string} */
com.inq.flash.client.data.MessageFields.TYPE_CHAT_ACTIVITY = "chat.activity";

/** @type {string} */
com.inq.flash.client.data.MessageFields.TYPE_CLIENT_AUTH_DATA = "client.auth.data";

/** @type {string} */
com.inq.flash.client.data.MessageFields.TYPE_CHAT_COMMUNICATION = "chat.communication";

/** @type {string} */
com.inq.flash.client.data.MessageFields.TYPE_CHAT_AUTOMATON_DATA = "chat.communication.automaton_data";

/** @type {string} */
com.inq.flash.client.data.MessageFields.TYPE_CHAT_COMMUNICATION_OPENER = "chat.communication.opener";

/** @type {string} */
com.inq.flash.client.data.MessageFields.TYPE_CHAT_COMMUNICATION_QUEUE = "chat.communication.queue";

/** @type {string} */
com.inq.flash.client.data.MessageFields.TYPE_CHAT_COMMUNICATION_SURVEY = "chat.communication.survey";

/** @type {string} */
com.inq.flash.client.data.MessageFields.TYPE_CHAT_COMMUNICATION_OUTCOME = "chat.communication_outcome";

/** @type {string} */
com.inq.flash.client.data.MessageFields.TYPE_CHAT_COMMUNICATION_SYSTEM = "chat.communication_system";

/** @type {string} */
com.inq.flash.client.data.MessageFields.TYPE_CHAT_REQUEST = "chat.request";

/** @type {string} */
com.inq.flash.client.data.MessageFields.TYPE_CHAT_REQUEST_RECONNECT = "chat.request.reconnect";

/** @type {string} */
com.inq.flash.client.data.MessageFields.TYPE_CHAT_AUTHORIZED = "chat.authorized";

/** @type {string} */
com.inq.flash.client.data.MessageFields.TYPE_CHAT_ACCEPTED = "chat.accepted";

/** @type {string} */
com.inq.flash.client.data.MessageFields.TYPE_CHATROOM_MEMBER_CONNECTED = "chatroom.member_connected";

/** @type {string} */
com.inq.flash.client.data.MessageFields.TYPE_CHATROOM_MEMBER_LOST = "chatroom.member_lost";

/** @type {string} */
com.inq.flash.client.data.MessageFields.TYPE_CHAT_TRANSFER_RESPONSE = "chat.transfer_response";

/** @type {string} */
com.inq.flash.client.data.MessageFields.TYPE_CHAT_SYSTEM = "chat.system";

/** @type {string} */
com.inq.flash.client.data.MessageFields.TYPE_AUTHENTICATED_USER_RESPONSE = "authenticated.user.response";

/** @type {string} */
com.inq.flash.client.data.MessageFields.TYPE_OWNER_TRANSFER_RESPONSE = "owner.transfer_response";

/** @type {string} */
com.inq.flash.client.data.MessageFields.TYPE_CHAT_EXIT = "chat.exit";

/** @type {string} */
com.inq.flash.client.data.MessageFields.TYPE_CHAT_DENIED = "chat.denied";

/** @type {string} */
com.inq.flash.client.data.MessageFields.TYPE_CHAT_DENIED_RECONNECT = "chat.denied.reconnect";

/** @type {string} */
com.inq.flash.client.data.MessageFields.KEY_CHAT_DENIED_REASON = "chat.denied.reason";

/** @type {string} */
com.inq.flash.client.data.MessageFields.DATA_CHAT_DENIED_WRONG_REQUEST_FOR_RECONNECT_REASON = "wrong_request_for_reconnect";

/** @type {string} */
com.inq.flash.client.data.MessageFields.TYPE_CLIENT_COMMAND = "client.command";

/** @type {string} */
com.inq.flash.client.data.MessageFields.TYPE_SYSTEM_DISCONNECT = "system.disconnect";

/** @type {string} */
com.inq.flash.client.data.MessageFields.TYPE_NINA_COACH_CHAT_TAKE_OVER = "nina.coach.chat.take.over";

/** @type {string} */
com.inq.flash.client.data.MessageFields.TYPE_SYSTEM = "system.";

/** @type {string} */
com.inq.flash.client.data.MessageFields.TYPE_ERROR = "error";

/** @type {string} */
com.inq.flash.client.data.MessageFields.TYPE_CHAT_NEED_WAIT = "chat.need_wait";

/** @type {string} */
com.inq.flash.client.data.MessageFields.TYPE_PERSISTENT_TRANSITION = "chat.per_xtion";

/** @type {string} */
com.inq.flash.client.data.MessageFields.TYPE_CONTINUE_TRANSITION = "chat.con_xtion";

/** @type {string} */
com.inq.flash.client.data.MessageFields.TYPE_GET_PERSISTENT_DOMAIN = "chat.get_pers";

/** @type {string} */
com.inq.flash.client.data.MessageFields.TYPE_SYNC = "sync";

/** @type {string} */
com.inq.flash.client.data.MessageFields.TYPE_CHAT_ACTIVE = "chat.active";

/** @type {string} */
com.inq.flash.client.data.MessageFields.TYPE_CHAT_AUTOMATON_RESPONSE = "chat.automaton_response";

/** @type {string} */
com.inq.flash.client.data.MessageFields.TYPE_CHAT_AUTOMATON_REQUEST = "chat.automaton_request";

/** @type {string} */
com.inq.flash.client.data.MessageFields.TYPE_CHAT_AUTOMATON_DATA_MAP = "chat.automaton_data_map";

/** @type {string} */
com.inq.flash.client.data.MessageFields.TYPE_CHAT_AUTOMATON_SETTING = "chat.setting";

/** @type {string} */
com.inq.flash.client.data.MessageFields.TYPE_NULL = "null";

/** @type {string} */
com.inq.flash.client.data.MessageFields.TYPE_CHAT_COBROWSE = "chat.cobrowse";

/** @type {string} */
com.inq.flash.client.data.MessageFields.TYPE_CHAT_FILEUPLOAD = "chat.fileUpload";

/** @type {string} */
com.inq.flash.client.data.MessageFields.TYPE_CHAT_VIDEOPLAYER_STATUS = "chat.video_player_status";

/** @type {string} */
com.inq.flash.client.data.MessageFields.TYPE_ASYNC_UNAUTH_TOKEN_INFO = "async.unauth.token.info";

com.inq.flash.client.data.MessageFields.KEY_VIDEO_URL = "video.url";

com.inq.flash.client.data.MessageFields.KEY_VIDEO_ACTION = "video.action";

/** @type {string} */
com.inq.flash.client.data.MessageFields.TYPE_CHAT_WEBCALL = "chat.webCall";

/** @type {string} */
com.inq.flash.client.data.MessageFields.KEY_COBROWSE_ENABLED = "cobrowse.enabled";

/** @type {string} */
com.inq.flash.client.data.MessageFields.KEY_COBROWSE_HIGHLIGHT_ENABLED = "cobrowse.highlight.enabled";

/** @type {string} */
com.inq.flash.client.data.MessageFields.KEY_COBROWSE_MINIMIZE_RESTORE_ENABLED = "cobrowse.minimize.restore.enabled";

/** @type {string} */
com.inq.flash.client.data.MessageFields.KEY_COBROWSE_EVENT = "cobrowse.event";

/** @type {string} */
com.inq.flash.client.data.MessageFields.KEY_COBROWSE_EVENT_TYPE_CLIENT_COBROWSE_ACCEPT = "45";

/** @type {string} */
com.inq.flash.client.data.MessageFields.KEY_COBROWSE_EVENT_TYPE_CLIENT_COBROWSE_DECLINE = "46";

/** @type {string} */
com.inq.flash.client.data.MessageFields.KEY_COBROWSE_EVENT_TYPE_CLIENT_COBROWSE_ACCEPT_SHARE = "47";

/** @type {string} */
com.inq.flash.client.data.MessageFields.KEY_COBROWSE_EVENT_TYPE_CLIENT_COBROWSE_DECLINE_SHARE = "48";

/** @type {string} */
com.inq.flash.client.data.MessageFields.KEY_COBROWSE_EVENT_TYPE_CLIENT_COBROWSE_END = "49";

/** @type {string} */
com.inq.flash.client.data.MessageFields.KEY_COBROWSE_EVENT_TYPE_AGENT_COBROWSE_SENT_INVITE = "50";

/** @type {string} */
com.inq.flash.client.data.MessageFields.KEY_COBROWSE_EVENT_TYPE_AGENT_COBROWSE_SENT_SHARED_INVITE = "51";

/** @type {string} */
com.inq.flash.client.data.MessageFields.KEY_COBROWSE_EVENT_TYPE_AGENT_COBROWSE_END = "52";

/** @type {string} */
com.inq.flash.client.data.MessageFields.KEY_AGENT_TYPE = "agentType";

/** @type {string} */
com.inq.flash.client.data.MessageFields.DATA_AGENT_TYPE_FLEX = "flex";

/** @type {string} */
com.inq.flash.client.data.MessageFields.KEY_COBROWSE_EVENT_TYPE_AGENT_COBROWSE_END_MESSAGE_FROM_CI = "521";

/** @type {string} */
com.inq.flash.client.data.MessageFields.KEY_COBROWSE_EVENT_TYPE_CLIENT_PERFORMANCE_TEST = "53";

/** @type {string} */
com.inq.flash.client.data.MessageFields.KEY_COBROWSE_EVENT_TYPE_CLIENT_INIT_FAIL = "54";

/** @type {string} */
com.inq.flash.client.data.MessageFields.KEY_COBROWSE_EVENT_TYPE_CLIENT_COBROWSE_SUPPRESSED = "55";

com.inq.flash.client.data.MessageFields.DATA_CLIENT_VIDEO_ACCEPT = "56";

com.inq.flash.client.data.MessageFields.DATA_CLIENT_VIDEO_DECLINE = "57";
com.inq.flash.client.data.MessageFields.DATA_CLIENT_VIDEO_STOP = "58";

/** @type {string} */
com.inq.flash.client.data.MessageFields.KEY_COBROWSE_EVENT_TYPE_ISSUE_PERSIST_ACCESS_TO_MAIN = "59";

com.inq.flash.client.data.MessageFields.KEY_COBROWSE_EVENT_TYPE_AGENT_COBROWSE_SENT_INVITE_TEST = "60";
com.inq.flash.client.data.MessageFields.KEY_COBROWSE_EVENT_TYPE_AGENT_COBROWSE_SENT_INVITE_TEST_RESULT = "62";

com.inq.flash.client.data.MessageFields.KEY_COBROWSE_EVENT_TYPE_AGENT_COBROWSE_SENT_FAIL_NO_CONNECTION = "63";

/** @type {string} */
com.inq.flash.client.data.MessageFields.KEY_TY_LABEL = "thank_you_image_label";

/** @type {string} */
com.inq.flash.client.data.MessageFields.KEY_CHAT_WAIT_EST_ASSIGN_TIME = "waitTime";

/** @type {string} */
com.inq.flash.client.data.MessageFields.KEY_CHAT_WAIT_POS = "queueDepth";

/** @type {string} */
com.inq.flash.client.data.MessageFields.KEY_MESSAGE_TIMESTAMP = "messageTimestamp";

/** @type {string} */
com.inq.flash.client.data.MessageFields.KEY_MESSAGE_TYPE = "messageType";

/** @type {string} */
com.inq.flash.client.data.MessageFields.KEY_VERSION = "version";

/** @type {string} */
com.inq.flash.client.data.MessageFields.KEY_ERROR_MSG = "error.msg";

/** @type {string} */
com.inq.flash.client.data.MessageFields.KEY_CLIENT_COMMAND_PARAM = "messageText";

/** @type {string} */
com.inq.flash.client.data.MessageFields.KEY_MESSAGE_DATA = "messageData";

/** @type {string} */
com.inq.flash.client.data.MessageFields.KEY_CLIENT_CMD_PARAM = "chat.cmd";

/** @type {string} */
com.inq.flash.client.data.MessageFields.KEY_CHATROUTER_ADDRESS = "chatrouter.address";

/** @type {string} */
com.inq.flash.client.data.MessageFields.KEY_REASON = "reason";

/** @type {string} */
com.inq.flash.client.data.MessageFields.KEY_CHAT_AUTOMATON_ID = "automaton.id";

/** @type {string} */
com.inq.flash.client.data.MessageFields.KEY_CHAT_AUTOMATON_FIELD = "automaton.field.";

/** @type {string} */
com.inq.flash.client.data.MessageFields.KEY_DATAPASS = "datapass";

/** @type {string} */
com.inq.flash.client.data.MessageFields.KEY_CLIENT_PAGE_LOCATION = "client.page.location";

/** @type {string} */
com.inq.flash.client.data.MessageFields.KEY_PAGE_MARKER_ID = "page.markerID";

/** @type {string} */
com.inq.flash.client.data.MessageFields.KEY_CONFIG_ENTRY_LOCATION = "config.location";

/** @type {string} */
com.inq.flash.client.data.MessageFields.KEY_CONFIG_ENTRY_INITIATOR = "config.initiator";

/** @type {string} */
com.inq.flash.client.data.MessageFields.KEY_CONFIG_FALLBACK_AGENT_GROUP_ENBLED = "config.fallback-agent-group-enabled";

/** @type {string} */
com.inq.flash.client.data.MessageFields.KEY_CHAT_AUTOMATON_TYPE = "automaton.type";

/** @type {string} */
com.inq.flash.client.data.MessageFields.KEY_DT_QUESTION = "dt.question";

/** @type {string} */
com.inq.flash.client.data.MessageFields.KEY_CHAT_AUTOMATON_STATE = "dt.state";

/** @type {string} */
com.inq.flash.client.data.MessageFields.KEY_CHAT_AUTOMATON_DATA_MODEL = "dt.datamodel";

/** @type {string} */
com.inq.flash.client.data.MessageFields.KEY_CHAT_AUTOMATON_EVENT = "dt.event";

/** @type {string} */
com.inq.flash.client.data.MessageFields.KEY_CHAT_AUTOMATON_DATA = "automaton.data";

/** @type {string} */
com.inq.flash.client.data.MessageFields.KEY_CHAT_ID = "engagementID";

/** @type {string} */
com.inq.flash.client.data.MessageFields.KEY_CLIENT_ID = "customerID";

/** @type {string} */
com.inq.flash.client.data.MessageFields.KEY_CUSTOMER_ID = "customerID";

/** @type {string} */
com.inq.flash.client.data.MessageFields.KEY_CONFIG_ENTRY_PERSISTENT_CUSTOMER_ID = "config.persist_cust.id";

/** @type {string} */
com.inq.flash.client.data.MessageFields.KEY_AUTHENTICATED_USER = "authenticatedUser";

/** @type {string} */
com.inq.flash.client.data.MessageFields.KEY_AGENT_ID = "agentID";

/** @type {string} */
com.inq.flash.client.data.MessageFields.KEY_ADVANCED_AGENT_ID = "advancedAgentID";

/** @type {string} */
com.inq.flash.client.data.MessageFields.KEY_PUBLIC_USER_ID = "public_user_id";

/** @type {string} */
com.inq.flash.client.data.MessageFields.KEY_USER_CID = "user.cid";

/** @type {string} */
com.inq.flash.client.data.MessageFields.KEY_USER_ID = "user.id";

/** @type {string} */
com.inq.flash.client.data.MessageFields.KEY_INITIATOR = "initiator";

/** @type {string} */
com.inq.flash.client.data.MessageFields.KEY_INITIATOR_ID = "initiator.id";

/** @type {string} */
com.inq.flash.client.data.MessageFields.KEY_SITE_ID = "config.site_id";

/** @type {string} */
com.inq.flash.client.data.MessageFields.KEY_LANGUAGE = "config.language";

/** @type {string} */
com.inq.flash.client.data.MessageFields.KEY_SCRIPT_ID = "config.script_id";

/** @type {string} */
com.inq.flash.client.data.MessageFields.KEY_AGENT_AUTO_OPENER_ID = "agent_auto_opener_id";

/** @type {string} */
com.inq.flash.client.data.MessageFields.KEY_AGENT_AUTO_OPENER = "agent_auto_opener";

/** @type {string} */
com.inq.flash.client.data.MessageFields.KEY_PROTODOMAIN = "pd";

/** @type {string} */
com.inq.flash.client.data.MessageFields.KEY_CONFIG_ENTRY_BUSINESS_UNIT_ID = "businessUnitID";

/** @type {string} */
com.inq.flash.client.data.MessageFields.KEY_CHAT_TITLE = "config.chat_title";

/** @type {string} */
com.inq.flash.client.data.MessageFields.KEY_BR_ID = "businessRuleID";

/** @type {string} */
com.inq.flash.client.data.MessageFields.KEY_QUEUE_THRESHOLD = "qt";

/** @type {string} */
com.inq.flash.client.data.MessageFields.KEY_EXTERNAL_CUSTOMER_IDS = "external_customer_ids";

/** @type {string} */
com.inq.flash.client.data.MessageFields.KEY_ROUTING_ALLOC_SPECS = "routing_alloc_specs";

/** @type {string} */
com.inq.flash.client.data.MessageFields.KEY_COUNTRY_CODE = "countryCode";

/** @type {string} */
com.inq.flash.client.data.MessageFields.KEY_REGION_CODE = "regionCode";

/** @type {string} */
com.inq.flash.client.data.MessageFields.KEY_AGENT_ALIAS = "config.agent_alias";

/** @type {string} */
com.inq.flash.client.data.MessageFields.KEY_AGENT_SITE_ATTRS = "agent.site_attrs";

/** @type {string} */
com.inq.flash.client.data.MessageFields.KEY_USE_AGENT_ALIAS = "config.use_agent_alias";

/** @type {string} */
com.inq.flash.client.data.MessageFields.KEY_TIME_DELTA = "time.delta";

/** @type {string} */
com.inq.flash.client.data.MessageFields.KEY_TIME_LOG = "time.log";

/** @type {string} */
com.inq.flash.client.data.MessageFields.KEY_CONFIG_AGENT_ATTRIBUTE = "config.agent_attributes";

/** @type {string} */
com.inq.flash.client.data.MessageFields.KEY_CONFIG_AGENT_GROUP_ID = "config.agent_group_id";

/** @type {string} */
com.inq.flash.client.data.MessageFields.KEY_MESSAGE_AGENT_ALIAS = "agent.alias";

/** @type {string} */
com.inq.flash.client.data.MessageFields.KEY_MESSAGE_CUSTOMER_QUIET = "customer.quiet";

/** @type {string} */
com.inq.flash.client.data.MessageFields.KEY_CONFIG_VISITOR_ATTRIBUTES = "config.visitor_attributes";

/** @type {string} */
com.inq.flash.client.data.MessageFields.KEY_CONFIG_RULE_ATTRIBUTES = "config.rule_attributes";

/** @type {string} */
com.inq.flash.client.data.MessageFields.KEY_CONFIG_ENTRY_BR_ID = "businessRuleID";

/** @type {string} */
com.inq.flash.client.data.MessageFields.KEY_CONFIG_ENTRY_DEVICE_TYPE = "config.device_type";

/** @type {string} */
com.inq.flash.client.data.MessageFields.KEY_CONFIG_ENTRY_BROWSER_TYPE = "config.browser_type";

/** @type {string} */
com.inq.flash.client.data.MessageFields.KEY_CONFIG_ENTRY_BROWSER_VERSION = "config.browser_version";

/** @type {string} */
com.inq.flash.client.data.MessageFields.KEY_CONFIG_ENTRY_OPERATING_SYSTEM_TYPE = "config.operating_system_type";

/** @type {string} */
com.inq.flash.client.data.MessageFields.KEY_CONFIG_ENTRY_LAUNCH_PAGE = "config.launch_page";

/** @type {string} */
com.inq.flash.client.data.MessageFields.KEY_CONFIG_ENTRY_LAUNCH_TYPE = "config.launch_type";

/** @type {string} */
com.inq.flash.client.data.MessageFields.KEY_CONFIG_ENTRY_INC_ASSIGNMENT_ID = "config.inc_assignment_id";

/** @type {string} */
com.inq.flash.client.data.MessageFields.KEY_CONFIG_AUTOMATON_DATA_MAP = "config.automaton_data_map";

/** @type {string} */
com.inq.flash.client.data.MessageFields.KEY_CONFIG_ENTRY_SESSION_ID = "config.session_id";

/** @type {string} */
com.inq.flash.client.data.MessageFields.KEY_CONFIG_ENTRY_PAGE_ID = "config.page_id";

/** @type {string} */
com.inq.flash.client.data.MessageFields.KEY_CONFIG_ENTRY_CUSTOMER_ID = "config.customer_id";

/** @type {string} */
com.inq.flash.client.data.MessageFields.KEY_CONFIG_IS_ASYNC_ENGAGEMENT = "config.is_async_engagement";

/** @type {string} */
com.inq.flash.client.data.MessageFields.KEY_CONFIG_CONVERSATION_CHANNEL = "conversationChannel";

/** @type {string} */
com.inq.flash.client.data.MessageFields.KEY_CHAT_DATA = "messageText";

/** @type {string} */
com.inq.flash.client.data.MessageFields.KEY_CLIENT_OUTCOME_DATA = "client.outcome.data";

/** @type {string} */
com.inq.flash.client.data.MessageFields.KEY_USERNAME = "client.name";

/** @type {string} */
com.inq.flash.client.data.MessageFields.KEY_RETURN_RECEIPT = "return.receipt";

/** @type {string} */
com.inq.flash.client.data.MessageFields.KEY_CLIENT_ECHO = "client.echo";

/** @type {string} */
com.inq.flash.client.data.MessageFields.KEY_REPLAY = "chat.replay";

/** @type {string} */
com.inq.flash.client.data.MessageFields.KEY_MSG_AGENT_ALIAS = "agent.alias";

/** @type {string} */
com.inq.flash.client.data.MessageFields.KEY_EVENT_AGENT_FIRST_NAME = "event.agent_first_name";

/** @type {string} */
com.inq.flash.client.data.MessageFields.KEY_EVENT_AGENT_LAST_NAME = "event.agent_last_name";

/** @type {string} */
com.inq.flash.client.data.MessageFields.KEY_EVENT_INITIAL_REQUEST_ATTRIBUTES = "event.initial_request_attributes";

/** @type {string} */
com.inq.flash.client.data.MessageFields.KEY_EVENT_TRANSFER_REQUEST_ATTRIBUTES = "event.transfer_request_attributes";

/** @type {string} */
com.inq.flash.client.data.MessageFields.KEY_EVENT_AGENT_IS_VIRTUAL = "event.agent_is_virtual";

/** @type {string} */
com.inq.flash.client.data.MessageFields.KEY_BUSINESS_UNIT_ID = "business_unit.id";

/** @type {string} */
com.inq.flash.client.data.MessageFields.KEY_AGENT_GROUP_ID = "agentGroupID";

/** @type {string} */
com.inq.flash.client.data.MessageFields.KEY_OPENING_SCRIPT = "chat.open_script";

/** @type {string} */
com.inq.flash.client.data.MessageFields.KEY_PERSISTENT_FLAG = "chat.persistent";

/** @type {string} */
com.inq.flash.client.data.MessageFields.KEY_INITIAL_CLICKSTREAM_PREFIX = "initial_data.";

/** @type {string} */
com.inq.flash.client.data.MessageFields.KEY_LINE_NR = "sequenceNumber";

/** @type {string} */
com.inq.flash.client.data.MessageFields.KEY_COB_TEST_RESULT = "cob_test_result";
com.inq.flash.client.data.MessageFields.KEY_COB_TEST_RESULT_SUCCESS = "success";
com.inq.flash.client.data.MessageFields.KEY_COB_TEST_RESULT_FAILURE = "failure";

/** @type {string} */
com.inq.flash.client.data.MessageFields.KEY_CALL_ENABLED = "call.enabled";

/** @type {string} */
com.inq.flash.client.data.MessageFields.TYPE_CLICK_2_CALL = "call.event";

/** @type {string} */
com.inq.flash.client.data.MessageFields.KEY_CALL_STATUS = "call.status";

/** @type {string} */
com.inq.flash.client.data.MessageFields.KEY_CALL_RESULT = "call.result";

/** @type {string} */
com.inq.flash.client.data.MessageFields.KEY_CALL_TERMINATED = "call.terminated_by_customer";

/** @type {string} */
com.inq.flash.client.data.MessageFields.TYPE_CHATLINE = "chatLine";

/** @type {string} */
com.inq.flash.client.data.MessageFields.TYPE_AGENT_DATA_PASS = "agentDataPass";

/** @type {string} */
com.inq.flash.client.data.MessageFields.TYPE_VA_DATA_PASS = "vaDataPass";

/** @type {string} */
com.inq.flash.client.data.MessageFields.TYPE_COMMAND = "command";

/** @type {string} */
com.inq.flash.client.data.MessageFields.TYPE_STATE_CHANGE = "stateChange";

/** @type {string} */
com.inq.flash.client.data.MessageFields.KEY_STATE = "state";

/** @type {string} */
com.inq.flash.client.data.MessageFields.DATA_STATE_QUEUED = "queued";

/** @type {string} */
com.inq.flash.client.data.MessageFields.DATA_STATE_ASSIGNED = "assigned";

/** @type {string} */
com.inq.flash.client.data.MessageFields.DATA_STATE_CLOSED = "closed";

/** @type {string} */
com.inq.flash.client.data.MessageFields.DATA_STATE_TRANSFER = "transfer";

/** @type {string} */
com.inq.flash.client.data.MessageFields.DATA_STATE_CONFERENCE = "conference";

/** @type {string} */
com.inq.flash.client.data.MessageFields.DATA_STATE_AGENT_IS_TYPING = "agentIsTyping";

/** @type {string} */
com.inq.flash.client.data.MessageFields.DATA_STATE_MOVED_TO_ASYNC = "movedToAsync";

/** @type {string} */
com.inq.flash.client.data.MessageFields.DATA_CHATROOM_MEMBER_AGENT = "agent";

/** @type {string} */
com.inq.flash.client.data.MessageFields.DATA_CHATROOM_MEMBER_VIRTUAL_AGENT = "virtual_agent";

/** @type {string} */
com.inq.flash.client.data.MessageFields.KEY_TRANSFER_TO_TC_LIVE_AGENT_DISABLED = "transfer_to_tc_live_agent.disabled";

/** @type {string} */
com.inq.flash.client.data.MessageFields.KEY_TYPE = "type";

/** @type {string} */
com.inq.flash.client.data.MessageFields.ACTIVITY_AGENT_TYPING = "2";

/** @type {string} */
com.inq.flash.client.data.MessageFields.ACTIVITY_CUSTOMER_TYPING = "3";

/** @type {string} */
com.inq.flash.client.data.MessageFields.ACTIVITY_CUSTOMER_STOPS_TYPING = "4";

/** @type {string} */
com.inq.flash.client.data.MessageFields.ACTIVITY_CUSTOMER_MINIMIZED = "11";

/** @type {string} */
com.inq.flash.client.data.MessageFields.ACTIVITY_CUSTOMER_RESTORED = "12";

/** @type {string} */
com.inq.flash.client.data.MessageFields.ACTIVITY_FILE_UPLOAD_PATH = "15";

/** @type {string} */
com.inq.flash.client.data.MessageFields.ACTIVITY_AGENT_STOPPED_TYPING = "16";

/** @type {string} */
com.inq.flash.client.data.MessageFields.KEY_TC_MODE = "tc.mode";

/** @type {string} */
com.inq.flash.client.data.MessageFields.KEY_OWNER = "owner";

/** @type {string} */
com.inq.flash.client.data.MessageFields.KEY_OWNER_ID = "owner.id";

/** @type {string} */
com.inq.flash.client.data.MessageFields.KEY_SCREENING = "screening";

/** @type {string} */
com.inq.flash.client.data.MessageFields.KEY_CHATROOM_MEMBER_ID = "chatroom.member.id";

/** @type {string} */
com.inq.flash.client.data.MessageFields.KEY_CHATROOM_MEMBER_TYPE = "chatroom.member.type";

/** @type {string} */
com.inq.flash.client.data.MessageFields.KEY_CLIENT_DISPLAY_TEXT = "client.display.text";

/** @type {string} */
com.inq.flash.client.data.MessageFields.KEY_DISPLAY_TEXT = "display.text";

/** @type {string} */
com.inq.flash.client.data.MessageFields.KEY_IS_REASSIGNMENT_MODE = "is_reassignment_mode";

/** @type {string} */
com.inq.flash.client.data.MessageFields.DATA_TRANSFER = "transfer";

/** @type {string} */
com.inq.flash.client.data.MessageFields.DATA_CONFERENCE = "conference";

/** @type {string} */
com.inq.flash.client.data.MessageFields.DATA_TRUE = "true";

/** @type {string} */
com.inq.flash.client.data.MessageFields.DATA_FALSE = "false";

/** @type {string} */
com.inq.flash.client.data.MessageFields.FORM_DATA = "form.data";

/** @type {string} */
com.inq.flash.client.data.MessageFields.FORM_NAME = "form.name";

/** @type {string} */
com.inq.flash.client.data.MessageFields.FORM_ID = "form.id";

/** @type {string} */
com.inq.flash.client.data.MessageFields.DATA_DTID = "dtid";

/** @type {string} */
com.inq.flash.client.data.MessageFields.DATA_CACHE_ID = "cacheId";

/** @type {string} */
com.inq.flash.client.data.MessageFields.DATA_LAYER_ID = "layerId";

/** @type {string} */
com.inq.flash.client.data.MessageFields.CUSTOMER_NAME_INPUT_FIELD = "customerNameInputField";

com.inq.flash.client.data.MessageFields.KEY_WEBCALL_ACTION = "chat.webCall.action";

/** @type {string} */
com.inq.flash.client.data.MessageFields.KEY_FILE_DELETE_SETTING = "fileDeleteSetting";

/** @type {string} */
com.inq.flash.client.data.MessageFields.KEY_CHAT_INFO = "/chatinfo";

/** @type {string} */
com.inq.flash.client.data.MessageFields.KEY_SWITCH_DEBUG = "/debug";

/** @type {string} */
com.inq.flash.client.data.MessageFields.WINDOW_ID_PARAM = "windowId";

/** @type {string} */
com.inq.flash.client.data.MessageFields.MASTER_WINDOW_ID = "masterWindowId";

/** @type {string} */
com.inq.flash.client.data.MessageFields.KEY_CSS_CLASS_NAME = "css.class_name";

/** @type {string} */
com.inq.flash.client.data.MessageFields.KEY_EXTERNAL_APP = "external.app";

/** @type {string} */
com.inq.flash.client.data.MessageFields.KEY_CONTEXT = "context";

/** @type {string} */
com.inq.flash.client.data.MessageFields.KEY_INITIAL_CLIENT_ID_STRING = "config.initial_customer.id";

/** @type {string} */
com.inq.flash.client.data.MessageFields.KEY_PUSH_NOTIFICATION_DEVICE_ID = "push_notification_device.id";

/** @type {string} */
com.inq.flash.client.data.MessageFields.KEY_CONVERSATION_RESOLVED = "conversation_resolved";

/** @type {string} */
com.inq.flash.client.data.MessageFields.KEY_CONVERSATION_ID = "conversationId";

/** @type {string} */
com.inq.flash.client.data.MessageFields.KEY_CONFIG_TOPIC_ID = "config.topic_id";

/** @type {string} */
com.inq.flash.client.data.MessageFields.KEY_CONFIG_TOPIC_NAME = "config.topic_name";

/** @type {string} */
com.inq.flash.client.data.MessageFields.KEY_TOPICS_ENABLED = "topics_enabled";

/** @type {string} */
com.inq.flash.client.data.MessageFields.KEY_USER_TYPE = "user.type";

/** @type {string} */
com.inq.flash.client.data.MessageFields.KEY_CONFIG_QUEUE_MESSAGING_SPEC_ID = "config.queue_messaging_spec_id";

/** @type {string} */
com.inq.flash.client.data.MessageFields.KEY_ASYNC_SURVEY_SPEC_ID = "async.survey.spec.id";

/** @type {string} */
com.inq.flash.client.data.MessageFields.KEY_CHAT_DATA_HIDDEN_FOR_CUSTOMER = "chat.data.hidden.from.customer";

/** @type {string} */
com.inq.flash.client.data.MessageFields.KEY_SECURE_WITH_CUST_TOKEN = "secureWithCustToken";

/** @type {string} */
com.inq.flash.client.data.MessageFields.KEY_SECURE_CUST_TOKEN = "secureCustToken";

/** @type {string} */
com.inq.flash.client.data.MessageFields.KEY_USER_OBJECT = "user_object";

/** @type {string} */
com.inq.flash.client.data.MessageFields.KEY_FOR_RECONNECT = "for_reconnect";

/** @type {string} */
com.inq.flash.client.data.MessageFields.KEY_CREATE_NEW_CONVERSATION = "create_new_conversation";

/** @type {string} */
com.inq.flash.client.data.MessageFields.KEY_FORCED_CLOSE = "forced_close";

/** @type {string} */
com.inq.flash.client.data.MessageFields.KEY_CONV_OBJECT_ID = "conversation.objectID";

/** @type {string} */
com.inq.flash.client.data.MessageFields.KEY_CONV_TOKEN_ID = "conversation.tokenID";

/** @type {string} */
com.inq.flash.client.data.MessageFields.KEY_LAST_AGENT_ASSIGNED_MESSAGE = "last_agent_assigned_message";

/** @type {string} */
com.inq.flash.client.data.MessageFields.KEY_TOKEN_ID = "tokenId";
/**
 * @type {string}
 */
com.inq.flash.client.data.MessageFields.KEY_CHAT_REINITIED = "ChatReInited";

